import CreateTeam from '../../pages/teams/CreateTeam.vue';
import SearchEmailAddresses from '../../pages/email-addresses/SearchEmailAddresses.vue';
import CreateUpdatesFile from '../../pages/ios_app/CreateUpdatesFile.vue';
import AdminMailgunDomains from '../../pages/mailgun/admin/AdminMailgunDomains.vue';

export default [
  {
    path: '/v2/admin/teams/create',
    name: 'admin.team.create',
    component: CreateTeam,
    meta: {
      title: 'Create Team',
    },
  },
  {
    path: '/v2/admin/email-addresses/search',
    name: 'admin.email_addresses.search',
    component: SearchEmailAddresses,
    meta: {
      title: 'Search Email Addresses',
    },
  },
  { // MLD-7393
    path: '/v2/admin/apple/updates-file',
    name: 'admin.apple.updates_file',
    component: CreateUpdatesFile,
    meta: {
      title: 'Create Updates File',
    },
  },
  { // MLD-8202
    path: '/v2/admin/employees/mailgun/domains',
    name: 'admin.employees.mailgun.domains',
    component: AdminMailgunDomains,
    meta: {
      title: 'Mailgun Domains',
    },
  },
]
